import styled, { css } from 'styled-components';

import { Rating as RatingTP } from '~/src/common/components/Rating/Rating';
import { getMediaQuery } from '~/src/common/utils/style';
import { tagStyle } from '~/src/screens/CatalogContent/ContentScreen/layout';
import { breakpoints, media } from '~/src/styles-constants';

export const GRID_AREA_HEADER = 'header';

export const PromoTag = styled.div<{
  $isBatchDiscount?: boolean;
}>`
  ${tagStyle};

  ${({ $isBatchDiscount }) => (!$isBatchDiscount ? 'font-size: 20px;' : '')};

  ${({ $isBatchDiscount }) => (!$isBatchDiscount ? media.M`font-size: 16px;` : '')};

  ${({ theme }) => css`
    color: ${theme.palette.common.BLACK};
    background-color: ${theme.palette.common.PROMOTION};
  `};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const PromoRange = styled.div`
  font-size: 14px;
  line-height: 24px;
`;

export const Label = styled.img`
  width: 24px;
  height: 24px;
`;

export const LabelTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.common.DISABLED};
`;

export const LabelName = styled.p`
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin: 0 0 0 4px;
`;

export const Origin = styled.span`
  color: ${({ theme }) => theme.palette.text};
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  ::first-letter {
    text-transform: uppercase;
  }
`;

export const Price = styled.span`
  margin-right: 13px;
  font-size: 20px;
  font-weight: 500;
`;

export const Granularity = styled.p`
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 16px;
  text-transform: capitalize;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

export const AddToCartActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 1;
  position: fixed;
  inset: auto 0 0;

  padding: 16px;
  padding-bottom: calc(env(safe-area-inset-bottom) + 16px);

  background: ${({ theme }) => theme.palette.background};
  border-top: ${({ theme }) => `1px solid ${theme.palette.common.BACKGROUND_3}`};

  ${media.M`
    position: initial;
    border: ${({ theme }) => `1px solid ${theme.palette.common.BACKGROUND_3}`};
    border-radius: 10px;
  `}
`;

export const ProductHeaderPaneContainer = styled.div`
  grid-area: ${GRID_AREA_HEADER};
  grid-column: 1;
  grid-row: 2;

  @media ${getMediaQuery(0, breakpoints.M)} {
    overflow: auto;
  }

  ${media.M`
    margin-bottom: 40px;
    grid-area: ${GRID_AREA_HEADER} / ${GRID_AREA_HEADER} / ${GRID_AREA_HEADER} / ${GRID_AREA_HEADER};
  `}
`;

export const PickerQuantity = styled.span`
  text-align: center;
  font-weight: 500;

  color: ${({ theme }) => theme.palette.common.BLACK};
  width: 48px;
  font-size: 20px;
`;

export const ButtonContainer = styled.div`
  button {
    min-width: 42px;
    min-height: 42px;
  }
`;

export const Unavailable = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  line-height: 20px;
`;

export const UnavailableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Rating = styled(RatingTP)`
  svg {
    width: 16px;
    height: 16px;
  }

  && p {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.common.TEXTS};
  }
`;

export const SeeAllRatingsContainer = styled.button`
  all: unset;
  cursor: pointer;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.common.PRIMARY};
  line-height: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
`;
